import { Box, Button, Modal, Paper, Typography } from '@mui/material';
import React, { Component, createRef } from 'react';

class SignaturePad extends Component {
  canvasRef = createRef();
  isDrawing = false;

  componentDidMount() {
    this.initCanvas();
    window.addEventListener('resize', this.initCanvas);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.initCanvas);
  }

  initCanvas = () => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext('2d');
    ctx.scale(ratio, ratio);
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  };

  getPos = e => {
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const source = e.touches ? e.touches[0] : e;
    return {
      x: source.clientX - rect.left,
      y: source.clientY - rect.top,
    };
  };

  handleStart = e => {
    e.preventDefault();
    this.isDrawing = true;
    const ctx = this.canvasRef.current.getContext('2d');
    const { x, y } = this.getPos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  handleMove = e => {
    e.preventDefault();
    if (!this.isDrawing) return;
    const ctx = this.canvasRef.current.getContext('2d');
    const { x, y } = this.getPos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  handleEnd = e => {
    e.preventDefault();
    this.isDrawing = false;
  };

  handleClear = () => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  isEmpty = () => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    return !data.some(channel => channel !== 0);
  };

  handleConfirm = () => {
    if (this.isEmpty()) {
      this.props.onEmpty?.();
      return;
    }
    const dataUrl = this.canvasRef.current.toDataURL('image/png');
    this.props.onConfirm(dataUrl);
  };

  render() {
    const { onCancel } = this.props;
    return (
      // 결제 서명은 실수로 닫히면 안 되므로 backdrop 클릭/ESC로는 닫지 않고 버튼으로만 동작
      <Modal
        open
        disableEscapeKeyDown
        sx={{ zIndex: 1300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Paper
          elevation={8}
          style={{
            position: 'relative',
            width: 'calc(100% - 32px)',
            maxWidth: '420px',
            padding: '16px',
            borderRadius: '16px',
            border: '2px solid #1976d2',
            outline: 'none',
          }}
        >
          <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '8px', textAlign: 'center' }}>
            서명을 입력해 주세요
          </Typography>
          <Box
            style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              background: '#fafafa',
              touchAction: 'none',
              userSelect: 'none',
            }}
          >
            <canvas
              ref={this.canvasRef}
              style={{ display: 'block', width: '100%', height: '180px', cursor: 'crosshair' }}
              onMouseDown={this.handleStart}
              onMouseMove={this.handleMove}
              onMouseUp={this.handleEnd}
              onMouseLeave={this.handleEnd}
              onTouchStart={this.handleStart}
              onTouchMove={this.handleMove}
              onTouchEnd={this.handleEnd}
            />
          </Box>
          <Box style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
            <Button variant="outlined" fullWidth onClick={this.handleClear}>
              초기화
            </Button>
            <Button variant="outlined" fullWidth color="inherit" onClick={onCancel}>
              취소
            </Button>
            <Button variant="contained" fullWidth color="primary" onClick={this.handleConfirm}>
              서명 완료
            </Button>
          </Box>
        </Paper>
      </Modal>
    );
  }
}

export default SignaturePad;
